module.exports = "https://lts-static.prod-my.games/promo/lp1/img/footer-age.1d3213e1.svg";